import api from './api';

const userService = {
  // Get User Profile
  getProfile: async () => {
    const response = await api.get('/user/profile');
    return response.data;
  },

  // Update User Profile
  updateProfile: async (data) => {
    const response = await api.put('/user', data);
    return response.data;
  },

  // Resubmit KYC
  resubmitKyc: async (data) => {
    const response = await api.post('/user/resubmit-kyc', data);
    return response.data;
  },

  // Change Password
  changePassword: async (data) => {
    const response = await api.post('/user/change-password', data);
    return response.data;
  },

  // Check KYC Status
  checkKycStatus: async (data) => {
    const response = await api.post('/user/check-kyc-status', data);
    return response.data;
  },
};

export default userService;
